import { exportRequestsFactory } from '@eas/common-web';
import { ExportTags } from '../../../../common/export-tags';

export const ExportRequests = exportRequestsFactory({
  exportTag: ExportTags.EXPORT_REQUEST_GRID,
});
